import { __module as useSyncExternalStore } from '../../../../../_virtual/index.js';
import { __require as requireUseSyncExternalStore_production_min } from './cjs/use-sync-external-store.production.min.js';
import { __require as requireUseSyncExternalStore_development } from './cjs/use-sync-external-store.development.js';

if (process.env.NODE_ENV === 'production') {
  useSyncExternalStore.exports = requireUseSyncExternalStore_production_min();
} else {
  useSyncExternalStore.exports = requireUseSyncExternalStore_development();
}

var useSyncExternalStoreExports = useSyncExternalStore.exports;

export { useSyncExternalStoreExports as u };
